//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DetailProcess',
  props: {
    examineData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      openStatus: false,
      onlyPerson: false,
      selectPerson: false,
      title: '选择成员',
      checkedList: [],
      examineList: [],
      activeDepartment: {},
      index: -1,
      isAppoint: false,
      appointList: [],
      indexCheck: undefined,
      hiddenKey: []
    };
  },
  watch: {
    examineData: {
      handler: function handler(nVal) {
        this.examineList = nVal.users;
        this.getChecked(nVal);
      },
      immediate: true
    },
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    getChecked: function getChecked(list) {
      if (list.users && list.users.length > 0) {
        this.indexCheck = list.users.findIndex(function (v) {
          return v.uniqued === list.node_id;
        });
      }
    },
    getExamineText: function getExamineText(id) {
      var str = '';
      if (id == 1) {
        str = '或签';
      } else if (id == 2) {
        str = '会签';
      } else if (id == 3) {
        str = '依次审批';
      }
      return str;
    },
    // 判断头像是否能显示
    judge: function judge(row) {
      if (row.card) {
        return row.card.avatar.includes('https');
      }
    },
    // 选择部门关闭
    departmentClose: function departmentClose() {
      this.openStatus = false;
    },
    deleteUsersItem: function deleteUsersItem(row, index) {
      row.splice(index, 1);
    },
    getDetailText: function getDetailText(type, status) {
      var str = '';
      if (type == 1 && status == 1) {
        str = '已通过 ';
      } else if (type == 1 && status == 2) {
        str = '已拒绝 ';
      } else if (type == 2 && status > 0) {
        str = '已抄送 ';
      }
      return str;
    },
    itemIsShow: function itemIsShow(row) {
      var keys = this.hiddenKey.indexOf(row.uniqued);
      if (keys > -1) {
        this.hiddenKey.splice(keys, 1);
      } else {
        this.hiddenKey.push(row.uniqued);
      }
    }
  }
};